import axios from 'axios'
import { MessageBox } from 'element-ui'
import vv from '@/components/varVariable'

// create an axios instance
axios.defaults.withCredentials = true
const service = axios.create({
  baseURL: vv.http, // url = base url + request url
  withCredentials: true, // 是否使用cookies
  // 请求超时时间
  // timeout: 5000
  timeout: 50000
})

// request interceptor
service.interceptors.request.use(
  config => {
    // form表单类型参数 Content type 'application/x-www-form-urlencoded;charset=UTF-8'
    const header = config.headers['Content-Type']
    config.headers['Content-Type'] = header || 'application/json;charset=UTF-8'
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 统一返回处理，如果请求失败则不向下返回数据
service.interceptors.response.use(
  ({ data: res }) => {
    try {
      if (res.code === 200 && res.success) {
        return res.data
      } else if (res.message) {
        MessageBox.alert(res.message, '错误提示').then(r => {})
      }
    } catch (e) {
      console.log(e)
    }
    return false
  },
  error => {
    console.log('err' + error) // for debug
    MessageBox.alert('操作失败, 请到控制台查看详情', '错误提示')
  }
)

export default service
